import React from 'react'
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import {LoginForm} from './login.react.js'
import {RegisterForm} from './register.react.js'


export const LoginOrRegister = React.createClass({
  getInitialState() {
    return {
      showLogin: false,
      showRegister: false,
    };
  },

  showLoginForm() {
    this.props.close()
    this.setState({showLogin: true})
  },

  showRegisterForm() {
    this.props.close()
    this.setState({showRegister: true})
  },

  closeForm() {
    this.setState({
      showLogin: false,
      showRegister: false,
    });
  },

  render() {
    return (
      <div>
        <LoginForm showModal={this.state.showLogin} close={this.closeForm}/>
        <RegisterForm showModal={this.state.showRegister} close={this.closeForm}/>

        <Modal show={this.props.showModal} onHide={this.props.close}>
          <form class='modal fade form_userinfo' method='POST' autocomplete>

            <Modal.Header closeButton>
              <Modal.Title>{this.props.formCaption}</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
              <Button onClick={this.props.close}>キャンセル</Button>
              <Button class='btn btn-primary' onClick={this.showRegisterForm}>ユーザ登録</Button>
              <Button class='btn btn-primary' onClick={this.showLoginForm}>ログイン</Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./components/loginorregister.react.js